/**
 * Bytes → a short human string, base-1024 with the conventional KB/MB/GB
 * labels (the app's established convention; not the SI KiB/MiB).
 *
 * `null`/`undefined` (= unknown size) renders the em-dash placeholder so an
 * unknown never reads as zero; `0` renders "0 B" so a genuine empty file keeps
 * its own rendering (the legacy `if (!bytes)` guard used to swallow it).
 *
 * Shared by the Vault grid (`formatFileSize`) and the usage grid.
 */
const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes)) return "—";
  if (bytes <= 0) return "0 B";
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), BYTE_UNITS.length - 1);
  return `${Math.round((bytes / Math.pow(1024, i)) * 100) / 100} ${BYTE_UNITS[i]}`;
}
